import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
    return {
        root: {
            flex: 1,
            height: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            padding: theme.spacing(0, 9),
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column-reverse',
                justifyContent: 'center',
            },
        },
        headingText: {
            fontWeight: 800,
            fontSize: '3rem',
            position: 'relative',
        },
        textDecoration: {
            position: 'absolute',
            top: -30,
            left: -40,
        },
        image: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            '& img': {
                width: '75%',
                height: '75%',
            },
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center',
                marginBottom: theme.spacing(4),
                '& img': {
                    width: '300px',
                    height: '300px',
                },
            },
            [theme.breakpoints.down('xs')]: {
                '& img': {
                    width: '200px',
                    height: '200px',
                },
            },
        },
        info: {
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
            },
        },
        goBack: {
            borderRadius: '20px',
            textTransform: 'none',
            padding: theme.spacing(1, 3),
        },
    };
});
